export default __webpack_public_path__ + "static/icon-lifetime-warranty-06a644ed4898baae7fa02f606a35cc93.png";